/*
 * @Date: 2023-12-20 14:31:55
 * @Author: jm
 * @LastEditTime: 2023-12-20 14:31:59
 * @LastEditors: jm
 * @FilePath: \MultiplePage-master\src\utils\common.js
 * @Description: 
 */
export default{
    a:'R9DhDXQt7xU',
    b:'PORQZJv7P1g==',
}